import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {CloudflareService} from "../../../services/cloudflare.service";
import * as fromStore from '../../../../../../store';
import {Store} from "@ngrx/store";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {VerifyHostnameComponent} from "../verify-cloudflare-hostname/verify-hostname.component";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {Subject} from "rxjs";
import {filter, first, takeUntil} from "rxjs/operators";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {Utils} from "../../../../../../shared/utils/utils";

@Component({
    selector: 'db-enable-cloudflare',
    templateUrl: './enable-cloudflare-dialog.component.html',
    styleUrls: ['./enable-cloudflare-dialog.component.scss'],
    standalone: false
})
export class EnableCloudflareDialogComponent implements OnInit {

  @Input() websiteId: number;
  @Input() websiteUrl: any;
  public dnsRecord: string = '';
  public server: string;
  public isMobile: boolean;
  public loading: boolean;
  public originalIpLoading: boolean = true;
  public serverIpForm: FormGroup;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dbModalService: DbModalService,
    private _activeModal: DbActiveModal,
    private _cloudflareService: CloudflareService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this._store.dispatch(new fromStore.LoadCloudflareDefaultRecord(this.websiteId));
    this.websiteUrl = this.websiteUrl && Utils.replaceUrl(this.websiteUrl);

    this.serverIpForm = new FormGroup({
      'serverIp': new FormControl( '', [Validators.required,
        Validators.pattern(`^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$`)])
    });
    this._getCFDefaultDnsRecord();
  }

  public resize(size: [number | null, number | null]): void {
    this._activeModal.resize(...size);
  }
  private _getCFDefaultDnsRecord(): void {
    this._store.select(fromStore.getCloudflareDefaultRecord(this.websiteId))
      .pipe (
        takeUntil(this._destroyStream$))
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data) && TypeUtils.isDefined(data)) {
          this.dnsRecord = data.dnsRecords && data.dnsRecords[0];
          this.server = data.server;
          this.server !== 'cloudflare' && this.serverIpForm.controls['serverIp'].setValue(this.dnsRecord);
          this.originalIpLoading = false;
        }
        this.resize([this.server !== 'cloudflare' ? 417 : null, 500]);
      });
  }

  public enable(): void {
    this.loading = true;
    this._cloudflareService.enableCloudflare(this.websiteId, this.serverIpForm.controls['serverIp'].value)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        this._activeModal.close();
        if (response.success) {
          // this._openDnsRecordDialog();
          this.sendEvent('Dashboard Action', 'Enable popup Proceed button click');
          this._store.dispatch( new fromStore.LoadWebsites());
          this._store.dispatch(new fromStore.LoadCloudflareData(this.websiteId));
        } else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  private _openDnsRecordDialog(): void {
    const modal = this._dbModalService.open(VerifyHostnameComponent);
    modal.componentInstance.websiteId = this.websiteId;
    modal.componentInstance.websiteUrl = this.websiteUrl;
    modal.componentInstance.dnsRecord = this.dnsRecord;
  }

  public close_window(): void {
    this._activeModal.close();
  }
  public sendEvent(category: string, action: string): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

}
